import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

interface EmployerInsiderInterviewState {
    articles: { code: number; title: string }[];
    employerId: number;
}

const employerInsiderInterview = autoGeneratedReducer<EmployerInsiderInterviewState>(null);
export { employerInsiderInterview };
